import { useRouter, useValidation } from '@application/utils';
import { QRCodePage } from '@presentation/pages';
import { useEffect, useState } from 'react';
import type { FC } from 'react';

export const QRCodePageController: FC = () => {
  const { infoFromCurrentPath, translate } = useRouter();
  const { isValidUrl } = useValidation();
  const id = infoFromCurrentPath.params[0];

  const redirectionUrl = translate(`qrcode.code${id}.redirectionUrl`);
  const [shouldRedirect, setShouldRedirect] = useState<boolean>(false);

  useEffect(() => {
    const trimmedUrl = redirectionUrl?.trim();
    const validUrl = isValidUrl(trimmedUrl);
    setShouldRedirect(validUrl);
  }, [redirectionUrl]);

  if (shouldRedirect) {
    window.location.href = redirectionUrl;
  }
  return <QRCodePage id={id} />;
};
